import { biApi } from "./path/biApi";

export const api = {
  ...biApi
};
